import React, { useState } from "react";
import { Icon, useToast } from "@chakra-ui/react";
import { FiEdit3 } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { BsCheckCircle } from "react-icons/bs";
import ResponsiveRow from "../../Common/Table/ResponsiveRow";
import TdType from "../../Common/Table/TdType";

const CategoryItem = ({
  category,
  setShowNewCategory,
  initialAction = "row",
  addCategory,
  updateCategory,
  deleteCategory,
  isEditable = true,
}) => {
  const [action, setAction] = useState(initialAction);
  const [newCategory, setNewCategory] = useState(category);
  const toast = useToast();

  const validateForm = async () => {
    if (!newCategory.name || !newCategory.order) {
      toast({
        title: "Se ha producido un error.",
        description: "Verifique todos los campos",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      let category = { ...newCategory };
      switch (action) {
        case "edit":
          await updateCategory(category);
          break;

        case "new":
          await addCategory(category);
          break;
      }
      setShowNewCategory(false);
      setAction("row");
    }
  };

  const handleCancel = () => {
    setAction("row");
  };

  const handleChange = (val) => {
    setNewCategory({ ...newCategory, [val.target.id]: val.target.value });
  };

  const handleEdit = () => {
    setAction("edit");
  };

  const handleSubmit = () => {
    validateForm();
  };

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "edit":
        rowData = [
          {
            item: (
              <TdType
                inputType="input"
                id="name"
                value={newCategory.name}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="order"
                value={newCategory.order}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => handleCancel(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow key={newCategory.id} cells={rowData}></ResponsiveRow>
        );

      case "new":
        rowData = [
          {
            item: (
              <TdType
                inputType="input"
                id="name"
                value={newCategory.name}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="order"
                value={newCategory.order}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => setShowNewCategory(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow key={newCategory.id} cells={rowData}></ResponsiveRow>
        );

      case "row":
        rowData = [
          {
            item: <TdType text={category.name} />,
          },
          {
            item: <TdType text={category.order} />,
          },

          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                {isEditable && (
                  <Icon
                    mx="2"
                    as={FiEdit3}
                    _hover={{ cursor: "pointer" }}
                    onClick={() => handleEdit(category)}
                    title={"Editar"}
                  ></Icon>
                )}
                <Icon
                  as={FiTrash2}
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  title="Eliminar"
                  onClick={() => deleteCategory(category)}
                />
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow key={category.id} cells={rowData}></ResponsiveRow>
        );
    }
  };

  return rowDisplay();
};

export default CategoryItem;
